import { FC } from 'react'
import { Box, Typography } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  height: 100%;
  gap: 24px;
`

const IconWrapper = styled(Box)`
  width: 128px;
  height: 128px;
  border-radius: 50%;
  border: 2px dashed #372e35;
  display: flex;
  align-items: center;
  justify-content: center;
`

const TextContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 416px;
  text-align: center;
`

const Title = styled(Typography)`
  font-family: ${theme.typography.fontFamily.primary};
  font-size: 24px;
  font-weight: ${theme.typography.fontWeight.bold};
  color: #e9e0e4;
  line-height: 24px;
`

const Subtitle = styled(Typography)`
  font-family: ${theme.typography.fontFamily.primary};
  font-size: 16px;
  font-weight: ${theme.typography.fontWeight.bold};
  color: #d0c3cc;
  line-height: 22px;
`

const ActivationPending: FC = () => (
  <Container>
    <IconWrapper>
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M24 16V24L30 30M42 24C42 33.9411 33.9411 42 24 42C14.0589 42 6 33.9411 6 24C6 14.0589 14.0589 6 24 6C33.9411 6 42 14.0589 42 24Z"
          stroke="#E9E0E4"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconWrapper>
    <TextContainer>
      <Title>Nexa AI is being activated</Title>
      <Subtitle>This may take up to a few minutes</Subtitle>
    </TextContainer>
  </Container>
)

export default ActivationPending
